export default __webpack_public_path__ + "static/media/sidebar-4.c2bf42d7.svg";